import { selectWarehouses } from 'containers/Warehouses/warehousesSlice'
import DropDownList from 'components/DropDownList'
import { LOCATION_STATES } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import FiltersElement from './FiltersElement'
import { useSelector } from 'react-redux'
import FilterButton from './FilterButton'
import FilterPopup from './FilterPopup'
import { Fragment } from 'react'
import './style.scss'

const Filters = ({ showFiltersBtn = false, selectedSort = undefined, selectSort = undefined, sortOptions = undefined, ...restProps }) => {
  const { filters, setFilters, fields } = restProps
  const warehouses = useSelector(selectWarehouses)
  const { popup, pathname } = usePopupState()

  const { push } = useHistory()
  const { t } = useTranslation('filters')
  const openFilters = () => push(pathname, LOCATION_STATES.popup('filters'))

  const removeAction = (key, secKey) => {
    const f = { ...filters }
    if (secKey) {
      delete f[key][secKey]
      if (Object.keys(f[key]).length === 0) delete f[key]

    } else delete f[key]
    setFilters(f)
  }

  const filtersList = Object.entries(filters)
  const list = filtersList.length > 0
    ? filtersList.map(([key, value], i) => {
      if (key === 'date') {
        const { start, end } = value
        return <Fragment key={i}>
          {start && <FiltersElement
            desc={start}
            label={`${t('date')} ${t('from')}`}
            openPopup={openFilters}
            removeAction={() => {
              removeAction(key, 'start')
            }} />}
          {end && <FiltersElement
            desc={end}
            label={`${t('date')} ${t('to')}`}
            openPopup={openFilters}
            removeAction={() => {
              removeAction(key, 'end')
            }} />}
        </Fragment>
      }

      const field = fields.find(({ name }) => name === key)
      return <FiltersElement
        key={i}
        desc={key === 'warehousesIds' && Array.isArray(value)
          ? value.reduce((r, v) => {
            if (r) r += ', '
            const selected = warehouses.find(w => w.objectId === v)
            r += selected ? `${selected.typeName} nr.${selected.name}` : v
            return r
          }, '')
          : value
        }
        openPopup={openFilters}
        label={field && field.label}
        removeAction={() => {
          removeAction(key)
        }} />
    })
    : undefined

  return (
    <div className='filters'>
      {popup === 'filters' && <FilterPopup {...restProps} />}
      {showFiltersBtn && sortOptions
        ? <div>
          <div className='filters__top group'>
            <FilterButton />
            <div className='center --gap05'>
              <i className='icon icon--sort' />
              <DropDownList
                selectedValue={selectedSort}
                changeValue={selectSort}
                list={sortOptions}
              />
            </div>
          </div>
          <div className='filters__list'>
            {list}
          </div>
        </div>
        : <div className='group'>
          <div className='filters__list'>
            {list}
          </div>
          {showFiltersBtn && <FilterButton />}
        </div>}
    </div>
  )
}

export default Filters